import moment, { Moment } from 'moment';
import momentFerie from 'moment-ferie-fr';
import { slots } from './interfaces';

export const isAppointmentAtNightOrSaturday = (appointmentDate: Moment) => {
  return (
    !(
      minutesOfDay(appointmentDate) >= minutesOfDay(moment(slots.am.start, 'HH')) &&
      minutesOfDay(appointmentDate) < minutesOfDay(moment(slots.evening.start, 'HH'))
    ) || appointmentDate.isoWeekday() === 6
  );
};

export const isAppointmentOnSundayOrHoliday = (appointmentDate: Moment) => {
  return !!(momentFerie(appointmentDate).isFerie() || appointmentDate.isoWeekday() === 7);
};

const minutesOfDay = (date: Moment) => date.minutes() + date.hours() * 60;
